import * as React from 'react'
import { getStyles } from './hooks'
import { Props as ServicesProps } from '../Services'
import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { useTheme } from '@mui/material/styles'

type Props = Pick<
  ServicesProps,
  'buttonFullWidth' | 'buttonClassName' | 'buttonVariant'
> & {
  addServiceButtonClick: () => void
  disabled: boolean
  loading: boolean
  newScreen?: boolean
}

export function AddServiceProductButton(props: Props) {
  const tidalThemeActive = useTidalThemeActive()
  const {
    addServiceButtonClick,
    buttonFullWidth,
    buttonClassName,
    buttonVariant = 'outlined',
    disabled,
    loading,
    newScreen,
  } = props
  const styles = getStyles(useTheme())
  return (
    <Stack direction="row">
      <Button
        color={newScreen && tidalThemeActive ? 'secondary' : 'primary'}
        fullWidth={buttonFullWidth}
        variant={buttonVariant}
        onClick={addServiceButtonClick}
        sx={{ textTransform: 'none', ...buttonClassName }}
        classes={
          buttonVariant === 'outlined'
            ? {
                root: `${styles.addRoot} ${styles.addLabel}`,
              }
            : undefined
        }
        disabled={disabled}
        data-test-id="addServiceOrProduct"
      >
        {loading && (
          <CircularProgress size="25px" style={{ position: 'absolute' }} />
        )}
        Add Service or Product
      </Button>
    </Stack>
  )
}
